import ChoiceVoteContent from '../../vote/ChoiceVoteContent.vue'
import ChoiceMoreRank from '../../vote/ChoiceMoreRank.vue'
import { createPopup } from '../../assets/js/factory'

export default {
  components: { ChoiceVoteContent },
  computed: {
    voteItems() {
      const results = []
      let { oidCountMap, totalNum } = this.question.vote
      const select = Array.isArray(this.issue.select) ? this.issue.select : [this.issue.select]
      totalNum += 1

      oidCountMap = Object.assign({}, oidCountMap)

      select.forEach(id => {
        oidCountMap[id] = oidCountMap[id] + 1
      })

      this.issue.items.forEach(item => {
        const voteNum = oidCountMap[item.id] || 0
        let percentage = totalNum ? Number((voteNum / totalNum * 100).toFixed(0)) : 0
        results.push({
          ...item,
          voteNum,
          percentage
        })
      })
      return results.sort((a, b) => b.voteNum - a.voteNum).map((item, index) => {
        return {
          ...item,
          num: index + 1
        }
      })
    },
  },
  methods:{
    onShowMoreRank() {
      createPopup(ChoiceMoreRank, {
        items: this.voteItems,
        question: this.question
      })
    }
  }
}